export const ROLE_TYPE_USER: number = 2;
export const ROLE_TYPE_LAWYER: number = 3;
export const ROLE_TYPE_COMPANY: number = 4;
